import PropTypes from 'prop-types';

export const getSliderStyles = () => {
  const sliderContainer = {
    position: 'relative',
    maxWidth: '400px',
    marginTop: '27px',
    marginBottom: '16px',
  };

  const sliderOverlay = {
    position: 'absolute',
    width: '100%',
    backgroundColor: '#CFE4FA',
    border: '1px solid #0F6CBD',
    top: '6px',
    height: '15px',
    '@media screen and (-ms-high-contrast: active) , (forced-colors: active) ': {
      border: '8px solid #BB4D38',
      top: '5px',
      'forced-color-adjust': 'none',
    },
    zIndex: '-1',
    borderRadius: '2px',
  };

  const paragraph = {
    fontSize: '12px',
  };

  const competitorHelpText = {
    ...paragraph,
    flexDirection: 'row',
    display: 'inline-flex',
    verticalAlign: 'top',
  };

  const competitorHelpIndicator = {
    backgroundColor: '#CFE4FA',
    border: '1px solid #0F6CBD',
    width: '12px !important',
    height: '12px',
    flexDirection: 'row',
    display: 'inline-flex',
    borderRadius: '2px',
    marginRight: '8px',
  };


  return {
    sliderContainer,
    sliderOverlay,
    competitorHelpIndicator,
    competitorHelpText,
  };
};

export const classesProps = PropTypes.shape({
  sliderContainer: PropTypes.shape({}),
  sliderOverlay: PropTypes.shape({}),
  slider: PropTypes.shape({}),
  competitorHelpIndicator: PropTypes.shape({}),
  competitorHelpText: PropTypes.shape({}),
  paragraph: PropTypes.shape({}),
});

export const sliderStyles = {
  activeSection: {
    backgroundColor: '#0F6CBD',
  },
  inactiveSection: {
    backgroundColor: '#616161 !important',
  },
  thumb: {
    border: '2px solid white !important',
    outline: '1px solid #c8c6c4',
    height: '16px',
    width: '16px',
    background: '#0F6CBD',
    cursor: 'pointer',
  },
};
